// extracted by mini-css-extract-plugin
export default {"modal":"TermOfUse_modal__i6Vy9","content":"TermOfUse_content__phmxC","text":"TermOfUse_text__o4L3M"};